import {
    EXPORT_CSV_ALERTS,
    EXPORT_CSV_ALERTS_SUCCESS,
    EXPORT_CSV_ALERTS_FAIL
} from './actionTypes';

const initialState = {
    csvToExport: null,
    error: null,
    loading: false,
    loaded: false
};

export function exportCsvReducer(state = initialState, action) {
    switch (action.type) {
        case EXPORT_CSV_ALERTS: {
            return {
                ...initialState,
                csvToExport: action.payload,
                loading: true
            };
        }
        case EXPORT_CSV_ALERTS_SUCCESS: {
            return {
                ...state,
                loading: false,
                loaded: true
            };
        }
        case EXPORT_CSV_ALERTS_FAIL: {
            return {
                ...initialState,
                error: action.payload
            };
        }
        default:
            return state;
    }
}
